import { Component } from '@angular/core';
import { HorizontalTopbarComponent } from '../horizontal-topbar/horizontal-topbar.component';
import { RightsidebarComponent } from '../rightsidebar/rightsidebar.component';
import { FooterComponent } from '../footer/footer.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { document } from 'ngx-bootstrap/utils';
import { LAYOUT_TYPES } from '@app/store/layouts/layout';
import { Store } from '@ngrx/store';
import { RootReducerState } from '@app/store';
import { changelayout } from '@app/store/layouts/layout-action';

@Component({
  selector: 'app-horizontal',
  standalone: true,
  imports: [TopbarComponent, SidebarComponent, RouterModule, FooterComponent, RightsidebarComponent, HorizontalTopbarComponent],
  templateUrl: './horizontal.component.html',
  styleUrl: './horizontal.component.scss'
})
export class HorizontalComponent {

  constructor(private store: Store<RootReducerState>) {
    window.addEventListener('resize', () => {
      this.changeLayout();
    })
    this.changeLayout();
  }

  changeLayout() {

    const layout = document.documentElement.clientWidth <= 1024 ? LAYOUT_TYPES.VERTICAL : LAYOUT_TYPES.HORIZONTAL;
    document.documentElement.setAttribute('data-layout', layout);
    this.store.dispatch(changelayout({layout}));
  }

  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    const rightBar = document.getElementById('theme-settings-offcanvas');
    if (rightBar != null) {
      rightBar.classList.toggle('show');
      rightBar.setAttribute('style', "visibility: visible;");

    }
  }

}
